import { render } from "./CustomerFeatures.vue?vue&type=template&id=ac520e24"
import script from "./CustomerFeatures.vue?vue&type=script&lang=js"
export * from "./CustomerFeatures.vue?vue&type=script&lang=js"

import "./CustomerFeatures.vue?vue&type=style&index=0&id=ac520e24&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__